import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on, Action } from '@ngrx/store';
import {
  DataPersonEntityRaw,
  DataPersonEntityId,
} from '@edgvr-front/data/domain';
import {
  DataPersonModulesListPageActions,
  DataPersonPersonsListPageActions,
} from '../actions';

export const DATA_PERSONS_FEATURE_KEY = 'data-persons';

export interface DataPersonsState extends EntityState<DataPersonEntityRaw> {
  count: number;
  page: number;
  loading: boolean;
  loaded: boolean;
  selectedDataPersonId: null | DataPersonEntityId;
  selectedDataModuleIndex: null | number;
}

export const dataPersonsAdapter: EntityAdapter<DataPersonEntityRaw> =
  createEntityAdapter<DataPersonEntityRaw>({
    sortComparer: (lhs: DataPersonEntityRaw, rhs: DataPersonEntityRaw) =>
      lhs.id - rhs.id,
    selectId: (_) => _.id,
  });

const initialState: DataPersonsState = dataPersonsAdapter.getInitialState({
  count: 0,
  page: 0,
  loading: false,
  loaded: false,
  selectedDataPersonId: null,
  selectedDataModuleIndex: null,
});

const reducer = createReducer(
  initialState,
  on(DataPersonModulesListPageActions.reset, (state) => ({
    ...state,
    selectedDataModuleIndex: null,
  })),
  on(DataPersonPersonsListPageActions.dataPersonsList, (state, { page }) => ({
    ...state,
    loading: true,
  })),
  on(
    DataPersonPersonsListPageActions.dataPersonsListSuccess,
    (state, { dataPersons, count, page }) =>
      dataPersonsAdapter.setMany(
        dataPersons.map((_) => _.toJSON()),
        {
          ...dataPersonsAdapter.removeAll(state),
          count,
          page,
          loading: false,
          loaded: true,
        }
      )
  ),
  on(DataPersonPersonsListPageActions.dataPersonsListFailure, (state) => ({
    ...state,
    loading: false,
  })),
  on(
    DataPersonModulesListPageActions.selectedDataPersonSet,
    (state, { id }) => ({
      ...state,
      selectedDataPersonId: id,
    })
  ),
  on(
    DataPersonModulesListPageActions.selectedDataPersonModuleSet,
    (state, { index }) => ({
      ...state,
      selectedDataModuleIndex: index,
    })
  ),
  on(
    DataPersonModulesListPageActions.dataPersonGetSuccess,
    (state, { dataPerson }) =>
      dataPersonsAdapter.setOne(dataPerson.toJSON(), state)
  )
);

export function dataPersonsReducer(
  state: DataPersonsState | undefined,
  action: Action
) {
  return reducer(state, action);
}
